import qs from 'query-string'

const customFieldsFromUrl = (keys: string[], search: string): Record<string, string> => {
  const query = qs.parse(search)

  return Object.fromEntries(
    keys.flatMap(key => {
      const value = [query[key]].flat()[0]
      return value ? [[key, value]] : []
    })
  )
}

export default customFieldsFromUrl
